<template>
  <div container>
    <div grid="row wrap" column="12">
      <div v-html="internalMembership_header_html"></div>
    </div>
    <div grid="row wrap" v-if="value.userMessage.length !==0 ">
      <ul>
        <li v-for="item in value.userMessage" >
          <p class="lips validation">{{ item}} </p>
        </li>
      </ul>
    </div>
    <div grid="row wrap">
      <div class="_mtxs" column="4">
        <app-select
          ref="initFileFormat"
          :errorMessage="initFileFormatError"
          :invalid="$v.internalValue.initFileFormat.$invalid"
          :options="initialMembershipFormatOptions"
          :required='false'
          label='Active Employee Membership Format'
          v-model="$v.internalValue.initFileFormat.$model"
          valueKey='initFileFormat'
          @input="emitInternalMembershipInformation()"
        />
      </div>
      <div class="_mtxs" column="4">
        <app-select
          :errorMessage="initFileSenderError"
          :invalid="$v.internalValue.initFileSender.$invalid"
          :options="fileSenderOptions"
          :required='false'
          @change='initMembershipSourceChanged'
          label='Active Employee Membership Source'
          v-model="$v.internalValue.initFileSender.$model"
          valueKey='initFileSender'
          @input="emitInternalMembershipInformation()"
        />
      </div>
      <div class="_mtxs" column="4">
        <app-input
          :disabled="initTPACompanyDisabled"
          :hidden="initTPACompanyDisabled"
          :errorMessage="initTpaCompNameError"
          :invalid="$v.internalValue.initTpaCompName.$invalid"
          label='TPA Company Name:'
          v-model="$v.internalValue.initTpaCompName.$model"
          valueKey='initTpaCompName'
          @input="emitInternalMembershipInformation()"
        />
      </div>
    </div>
    <div grid="row wrap">
      <div class="_mtxs" column="3">
        <app-input
          :errorMessage="initContactFnError"
          :invalid="$v.internalValue.initContactFn.$invalid"
          label='Contact First Name:'
          v-model="$v.internalValue.initContactFn.$model"
          valueKey='initContactFn'
          @input="emitInternalMembershipInformation()"
        />
      </div>
      <div class="_mtxs" column="3">
        <app-input
          :errorMessage="initContactLnError"
          :invalid="$v.internalValue.initContactLn.$invalid"
          label='Contact Last Name:'
          v-model="$v.internalValue.initContactLn.$model"
          valueKey='initContactLn'
          @input="emitInternalMembershipInformation()"
        />
      </div>
      <div class="_mtxs" column="3">
        <app-input
          :errorMessage="initContactEmailError"
          :invalid="$v.internalValue.initContactEmail.$invalid"
          label='Contact Email:'
          v-model="$v.internalValue.initContactEmail.$model"
          valueKey='initContactEmail'
          @input="emitInternalMembershipInformation()"
        />
      </div>
      <div class="_mtxs" column="3">
        <app-input
          :errorMessage="initContactPhoneError"
          :invalid="$v.internalValue.initContactPhone.$invalid"
          :required="false"
          label="Contact Phone:"
          v-model="$v.internalValue.initContactPhone.$model"
          valueKey="initContactPhone"
          maxlength="12"
          :pattern="[0-9]"
          @input="[formatInitContactPhone(),emitInternalMembershipInformation()]"
        />
      </div>
    </div>
    <div grid="row wrap">
      <div class="_mtxs" column="4">
        <app-date-input
          :errorMessage="initExpFileDateError"
          :invalid="$v.internalValue.initExpFileDate.$invalid"
          :required='false'
          format="YYYY-MM-DD"
          label='Expected Date For Initial Membership:'
          v-model="$v.internalValue.initExpFileDate.$model"
          valueKey="initExpFileDate"
          @input="emitInternalMembershipInformation()"
        />
      </div>
      <div class="_mtxs" column="4">
        <app-select
          :errorMessage="initIncludeCobraError"
          :invalid="$v.internalValue.initIncludeCobra.$invalid"
          :options="membershipCobraOptions"
          :required='false'
          @change='initIncludeCobraChanged'
          label='Will Initial Membership Include COBRA?'
          v-model="$v.internalValue.initIncludeCobra.$model"
          valueKey='initIncludeCobra'
          @input="emitInternalMembershipInformation()"
        />
      </div>
    </div>
    <div :hidden="initAddlCobraDisabled" id="cobraSection">
      <div grid="row wrap" column="12">
        <div v-html="internalMembership_cobra_header_html"></div>
      </div>
      <div grid="row wrap">
        <div class="_mtxs" column="4">
          <app-select
            :errorMessage="initCobraFileFormatError"
            :invalid="$v.internalValue.initCobraFileFormat.$invalid"
            :options="initialMembershipFormatOptions"
            :required='false'
            label='COBRA Employee Membership Format:'
            v-model="$v.internalValue.initCobraFileFormat.$model"
            valueKey='initCobraFileFormat'
            @input="emitInternalMembershipInformation()"
          />
        </div>
        <div class="_mtxs" column="4">
          <app-select
            :errorMessage="initCobraFileSenderError"
            :invalid="$v.internalValue.initCobraFileSender.$invalid"
            :options="fileSenderOptions"
            :required='false'
            @change='initCobraMembershipSourceChanged'
            label='COBRA Employee Enrollment Source'
            v-model="$v.internalValue.initCobraFileSender.$model"
            valueKey='initCobraFileSender'
            @input="emitInternalMembershipInformation()"
          />
        </div>
        <div class="_mtxs" column="4">
          <app-input
            :disabled="initCobraTPACompanyDisabled"
            :hidden="initCobraTPACompanyDisabled"
            :errorMessage="initCobraTpaCompNameError"
            :invalid="$v.internalValue.initCobraTpaCompName.$invalid"
            label='TPA Company Name:'
            v-model="$v.internalValue.initCobraTpaCompName.$model"
            valueKey='initCobraTpaCompName'
            @input="emitInternalMembershipInformation()"
          />
        </div>
      </div>
      <div grid="row wrap">
        <div class="_mtxs" column="3">
          <app-input
            :errorMessage="initCobraContactFnError"
            :invalid="$v.internalValue.initCobraContactFn.$invalid"
            label='Contact First Name:'
            v-model="$v.internalValue.initCobraContactFn.$model"
            valueKey='initCobraContactFn'
            @input="emitInternalMembershipInformation()"
          />
        </div>
        <div class="_mtxs" column="3">
          <app-input
            :errorMessage="initCobraContactLnError"
            :invalid="$v.internalValue.initCobraContactLn.$invalid"
            label='Contact Last Name:'
            v-model="$v.internalValue.initCobraContactLn.$model"
            valueKey='initCobraContactLn'
            @input="emitInternalMembershipInformation()"
          />
        </div>
        <div class="_mtxs" column="3">
          <app-input
            :errorMessage="initCobraContactEmailError"
            :invalid="$v.internalValue.initCobraContactEmail.$invalid"
            label='Contact Email:'
            v-model="$v.internalValue.initCobraContactEmail.$model"
            valueKey='initCobraContactEmail'
            @input="emitInternalMembershipInformation()"
          />
        </div>
        <div class="_mtxs" column="3">
          <app-input
            :errorMessage="initCobraContactPhoneError"
            :invalid="$v.internalValue.initCobraContactPhone.$invalid"
            :required="false"
            label="Contact Phone:"
            v-model="$v.internalValue.initCobraContactPhone.$model"
            valueKey="initCobraContactPhone"
            maxlength="12"
            :pattern="[0-9]"
            @input="[formatInitCobraContactPhone(),emitInternalMembershipInformation()]"
          />
        </div>
      </div>
      <div grid="row wrap">
        <div class="_mtxs" column="4">
          <app-date-input
            :errorMessage="initCobraExpFileDateError"
            :invalid="$v.internalValue.initCobraExpFileDate.$invalid"
            :required='false'
            format="YYYY-MM-DD"
            label='Expected Date For COBRA Membership:'
            v-model="$v.internalValue.initCobraExpFileDate.$model"
            valueKey="initCobraExpFileDate"
            @input="emitInternalMembershipInformation()"
          />
        </div>
      </div>
    </div>
    <div grid="row wrap">
      <button
        @click="saveInternalMembershipInformation()" class="btn --sm _mtxs"
        column="12"
        :disabled="$v.$invalid || hasTitleSectionError"
      >
        Continue
      </button>
    </div>
    <div>
      <hr class="_mbxs _mts">
    </div>
  </div>
</template>

<script>
  import AppInput from '@atoms/Input'
  import AppSelect from '@atoms/Select'
  import AppDateInput from '@atoms/DateInput'
  import SelectOptions from '@mixins/clientOnboardSelectOptions'
  import { email, maxLength, requiredIf } from 'vuelidate/lib/validators'
  import { currentOrFutureDate, formatPhone, twelveDigitsLong } from '@/utils'
  import clientOnboardVerbiage from '@mixins/clientOnboardVerbiage'
  import { eventBus } from '@/main'

  export default {
    mixins: [
      SelectOptions,
      clientOnboardVerbiage
    ],
    components: {
      AppInput,
      AppSelect,
      AppDateInput
    },
    props: {
      value: {
        type: Object
      }
    },
    data() {
      return {
        isLastSigner: this.value.initialMembershipValues.isLastSigner,
        hasTitleSectionError: this.value.initialMembershipValues.hasTitleSectionError,
        internalValue: {
          initFileFormat: this.value.initialMembershipValues.initFileFormat || '',
          initFileSender: this.value.initialMembershipValues.initFileSender || '',
          initIncludeCobra: this.value.initialMembershipValues.initIncludeCobra || '',
          initExpFileDate: this.value.initialMembershipValues.initExpFileDate || '',
          initTpaCompName: this.value.initialMembershipValues.initTpaCompName || '',
          initContactFn: this.value.initialMembershipValues.initContactFn || '',
          initContactLn: this.value.initialMembershipValues.initContactLn || '',
          initContactEmail: this.value.initialMembershipValues.initContactEmail || '',
          initContactPhone: this.value.initialMembershipValues.initContactPhone || '',
          initCobraFileFormat: this.value.initialMembershipValues.initCobraFileFormat || '',
          initCobraFileSender: this.value.initialMembershipValues.initCobraFileSender || '',
          initCobraExpFileDate: this.value.initialMembershipValues.initCobraExpFileDate || '',
          initCobraTpaCompName: this.value.initialMembershipValues.initCobraTpaCompName || '',
          initCobraContactFn: this.value.initialMembershipValues.initCobraContactFn || '',
          initCobraContactLn: this.value.initialMembershipValues.initCobraContactLn || '',
          initCobraContactEmail: this.value.initialMembershipValues.initCobraContactEmail || '',
          initCobraContactPhone: this.value.initialMembershipValues.initCobraContactPhone || ''
        },
        initAddlCobraDisabled: true,
        initTPACompanyDisabled: true,
        initCobraTPACompanyDisabled: true
      }
    },
    validations: {
      internalValue: {
        initFileFormat: {
          required: requiredIf(function () {
            return this.isLastSigner
          })
        },
        initFileSender: {
          required: requiredIf(function () {
            return this.isLastSigner
          })
        },
        initIncludeCobra: {
          required: requiredIf(function () {
            return this.isLastSigner
          })
        },
        initExpFileDate: {
          required: requiredIf(function () {
            return this.isLastSigner
          }),
          currentOrFutureDate
        },
        initTpaCompName: {
          required: requiredIf(function () {
            return !this.initTPACompanyDisabled
          }),
          maxLength: maxLength(40)
        },
        initContactFn: {
          required: requiredIf(function () {
            return this.isLastSigner
          }),
          maxLength: maxLength(27)
        },
        initContactLn: {
          required: requiredIf(function () {
            return this.isLastSigner
          }),
          maxLength: maxLength(27)
        },
        initContactEmail: {
          required: requiredIf(function () {
            return this.isLastSigner
          }),
          email,
          maxLength: maxLength(77)
        },
        initContactPhone: {
          required: requiredIf(function () {
            return this.isLastSigner
          }),
          twelveDigitsLong
        },
        initCobraFileFormat: {
          required: requiredIf(function () {
            return this.isLastSigner && !this.initAddlCobraDisabled
          })
        },
        initCobraFileSender: {
          required: requiredIf(function () {
            return this.isLastSigner && !this.initAddlCobraDisabled
          })
        },
        initCobraExpFileDate: {
          required: requiredIf(function () {
            return this.isLastSigner && !this.initAddlCobraDisabled
          }),
          currentOrFutureDate
        },
        initCobraTpaCompName: {
          required: requiredIf(function () {
            return !this.initAddlCobraDisabled && !this.initCobraTPACompanyDisabled
          }),
          maxLength: maxLength(40)
        },
        initCobraContactFn: {
          required: requiredIf(function () {
            return this.isLastSigner && !this.initAddlCobraDisabled
          }),
          maxLength: maxLength(27)
        },
        initCobraContactLn: {
          required: requiredIf(function () {
            return this.isLastSigner && !this.initAddlCobraDisabled
          }),
          maxLength: maxLength(27)
        },
        initCobraContactEmail: {
          required: requiredIf(function () {
            return this.isLastSigner && !this.initAddlCobraDisabled
          }),
          email,
          maxLength: maxLength(77)
        },
        initCobraContactPhone: {
          required: requiredIf(function () {
            return this.isLastSigner && !this.initAddlCobraDisabled
          }),
          twelveDigitsLong
        }
      }
    },
    computed: {
      initFileFormatError() {
        if (!this.$v.internalValue.initFileFormat.required) {
          return 'required'
        }
        return null
      },
      initFileSenderError() {
        if (!this.$v.internalValue.initFileSender.required) {
          return 'required'
        }
        return null
      },
      initIncludeCobraError() {
        if (!this.$v.internalValue.initIncludeCobra.required) {
          return 'required'
        }
        return null
      },
      initExpFileDateError() {
        if (!this.$v.internalValue.initExpFileDate.required) {
          return 'required'
        } else if (!this.$v.internalValue.initExpFileDate.currentOrFutureDate) {
          return 'past date is not allowed'
        }
        return null
      },
      initTpaCompNameError() {
        if (!this.$v.internalValue.initTpaCompName.required) {
          return 'required'
        } else if (!this.$v.internalValue.initTpaCompName.maxLength) {
          return 'character limit exceeded'
        }
        return null
      },
      initContactFnError() {
        if (!this.$v.internalValue.initContactFn.required) {
          return 'required'
        } else if (!this.$v.internalValue.initContactFn.maxLength) {
          return 'character limit exceeded'
        }
        return null
      },
      initContactLnError() {
        if (!this.$v.internalValue.initContactLn.required) {
          return 'required'
        } else if (!this.$v.internalValue.initContactLn.maxLength) {
          return 'character limit exceeded'
        }
        return null
      },
      initContactEmailError() {
        if (!this.$v.internalValue.initContactEmail.required) {
          return 'required'
        } else if (!this.$v.internalValue.initContactEmail.email) {
          return 'not a valid email address'
        } else if (!this.$v.internalValue.initContactEmail.maxLength) {
          return 'character limit exceeded'
        }
        return null
      },
      initContactPhoneError() {
        if (!this.$v.internalValue.initContactPhone.required) {
          return 'required'
        } else if (!this.$v.internalValue.initContactPhone.twelveDigitsLong) {
          return '10 digits long'
        }
        return null
      },
      initCobraFileFormatError() {
        if (!this.$v.internalValue.initCobraFileFormat.required) {
          return 'required'
        }
        return null
      },
      initCobraFileSenderError() {
        if (!this.$v.internalValue.initCobraFileSender.required) {
          return 'required'
        }
        return null
      },
      initCobraExpFileDateError() {
        if (!this.$v.internalValue.initCobraExpFileDate.required) {
          return 'required'
        } else if (!this.$v.internalValue.initCobraExpFileDate.currentOrFutureDate) {
          return 'past date is not allowed'
        }
        return null
      },
      initCobraTpaCompNameError() {
        if (!this.$v.internalValue.initCobraTpaCompName.required) {
          return 'required'
        } else if (!this.$v.internalValue.initCobraTpaCompName.maxLength) {
          return 'character limit exceeded'
        }
        return null
      },
      initCobraContactFnError() {
        if (!this.$v.internalValue.initCobraContactFn.required) {
          return 'required'
        } else if (!this.$v.internalValue.initCobraContactFn.maxLength) {
          return 'character limit exceeded'
        }
        return null
      },
      initCobraContactLnError() {
        if (!this.$v.internalValue.initCobraContactLn.required) {
          return 'required'
        } else if (!this.$v.internalValue.initCobraContactLn.maxLength) {
          return 'character limit exceeded'
        }
        return null
      },
      initCobraContactEmailError() {
        if (!this.$v.internalValue.initCobraContactEmail.required) {
          return 'required'
        } else if (!this.$v.internalValue.initCobraContactEmail.email) {
          return 'not a valid email address'
        } else if (!this.$v.internalValue.initCobraContactEmail.maxLength) {
          return 'character limit exceeded'
        }
        return null
      },
      initCobraContactPhoneError() {
        if (!this.$v.internalValue.initCobraContactPhone.required) {
          return 'required'
        } else if (!this.$v.internalValue.initCobraContactPhone.twelveDigitsLong) {
          return '10 digits long'
        }
        return null
      }
    },
    methods: {
      initIncludeCobraChanged() {
        if (this.internalValue.initIncludeCobra === '' || this.internalValue.initIncludeCobra === null ||
          this.internalValue.initIncludeCobra === 'O' || this.internalValue.initIncludeCobra === 'Y') {
          this.initAddlCobraDisabled = true
          this.internalValue.initCobraFileFormat = ''
          this.internalValue.initCobraFileSender = ''
          this.internalValue.initCobraExpFileDate = ''
          this.internalValue.initCobraTpaCompName = ''
          this.internalValue.initCobraContactFn = ''
          this.internalValue.initCobraContactLn = ''
          this.internalValue.initCobraContactEmail = ''
          this.internalValue.initCobraContactPhone = ''
        } else {
          this.initAddlCobraDisabled = false
        }
      },
      initMembershipSourceChanged() {
        if (this.internalValue.initFileSender === 'TPA') {
          this.initTPACompanyDisabled = false
        } else {
          this.initTPACompanyDisabled = true
          this.internalValue.initTpaCompName = ''
        }
      },
      initCobraMembershipSourceChanged() {
        if (this.internalValue.initCobraFileSender === 'TPA') {
          this.initCobraTPACompanyDisabled = false
        } else {
          this.initCobraTPACompanyDisabled = true
          this.internalValue.initCobraTpaCompName = ''
        }
      },
      formatInitContactPhone() {
        this.internalValue.initContactPhone = formatPhone(this.internalValue.initContactPhone)
      },
      formatInitCobraContactPhone() {
        this.internalValue.initCobraContactPhone = formatPhone(this.internalValue.initCobraContactPhone)
      },
      isFormValid() {
        this.$v.$touch()
        return !this.$v.$error
      },
      saveInternalMembershipInformation() {
        if (this.isFormValid()) {
          this.$emit('continue', this.internalValue)
        }
      },
      emitInternalMembershipInformation() {
        this.$emit('initialMemInfoUpdated', this.internalValue)
      }
    },
    mounted() {
      this.$refs.initFileFormat.$el.children[1].focus()
      setTimeout(() => document.getElementById('InternalMembershipTitle').scrollIntoView(), 100)
      this.initMembershipSourceChanged()
      this.initCobraMembershipSourceChanged()
      this.initIncludeCobraChanged()
      this.emitInternalMembershipInformation()
    },
    created() {
      eventBus.$on('groupTitleSectionHasError', (data) => {
        this.hasTitleSectionError = data
      })
    },
    watch: {
      internalValue: {
        deep: true,
        handler() {
          this.$emit('valueChanged', true)
        }
      }
    }
  }
</script>
